'use strict';

angular.module('amexReconciliationApp')
  .service('SiteConfigModel', function SiteConfigModel($rootScope,
                                                       roles,
                                                       TransactionSearchModel,
                                                       SiteConfigRepository,
                                                       ModelFactory,
                                                       UserModel,
                                                       CompanyRepository) {
    var siteConfigModel = ModelFactory.create('SiteConfigModel', ['siteConfig']);

    var lastLoadedSiteNumber;
      var selectedFileds = [
          'Cardmember Name and Card Number',
          'Cardmember Name',
          'Description 1',
          'Description 2',
          'Description 3',
          'Description 4',
          'Cardmember Reference 1',
          'Cardmember Reference 2',
          'Cardmember Reference 3',
          'Cardmember Reference 4',
          'Business Process Date',
          'Local Amount & Currency Code',
          'Last Updated',
          'Billed Tax Amount',
          'Transaction Reference Number',
          'OpenText 17',
          'OpenText 18',
          'OpenText 19',
          'OpenText 20',
          'Traveler Name',
          'Ticket Number',
          'Merchant Location',
          'Merchant Reference Number',
          'PO#',
          'PO Number',
          'Pre Auth Id'
      ];


    TransactionSearchModel.onParamsChanged($rootScope, handleSiteUpdate);


    function handleSiteUpdate() {
      var newSiteNumber = TransactionSearchModel.siteNumber();
      if (newSiteNumber) {
        if (lastLoadedSiteNumber === newSiteNumber) {
          return;
        }

        SiteConfigRepository.findSiteConfig(newSiteNumber).then(function (siteConfig) {
          siteConfigModel.siteConfig(siteConfig);
          lastLoadedSiteNumber = newSiteNumber;
          CompanyRepository.findByCompanyId(siteConfig.companyId).then(function (companyResource) {
            siteConfigModel.siteConfig().companyName = companyResource.companyName;
          });
        });
      }
    }

    siteConfigModel.companyId = function() {
      return _.get(siteConfigModel.siteConfig(), 'companyId', 0);
    };

    siteConfigModel.siteNumber = function() {
      return _.get(siteConfigModel.siteConfig(), 'siteNumber', 0);
    };
    
    siteConfigModel.siteName = function() {
      return _.get(siteConfigModel.siteConfig(), 'siteName', '');
    };

    siteConfigModel.getAccountingFieldSchemas = function() {
      return _.sortBy(_.get(siteConfigModel.siteConfig(), 'accountingFieldSchemas', []),'displayIndex'); 
    };

    siteConfigModel.cycleReceiptsEnabled = function () {
      return siteForReceipts('CYC');
    };

    siteConfigModel.transactionReceiptsEnabled = function () {
      return siteForReceipts('TRN');
    };

    siteConfigModel.siteForTransactionReceipts = function () {
      return siteForReceipts('TRN');
    };

    siteConfigModel.isPreAuth = function () {
      var productType = _.get(siteConfigModel.siteConfig(), 'productType');

      return _.includes(['VPAYMENT', 'VNG_BTA', 'VNG_CPC'], productType);
    };

    siteConfigModel.isBta = function () {
      return _.get(siteConfigModel.siteConfig(), 'businessTravelAccount', false);
    };
    
    siteConfigModel.isVngBtaProductType = function() {
      var productType = _.get(siteConfigModel.siteConfig(), 'productType');
      return productType === 'VNG_BTA'; 
    };

    siteConfigModel.isVngCpcProductType = function() {
      var productType = _.get(siteConfigModel.siteConfig(), 'productType');
      return productType === 'VNG_CPC';
    };

    siteConfigModel.isBtaProductType = function () {
      var productType = _.get(siteConfigModel.siteConfig(), 'productType');
      return productType === 'BTA';
    };

    siteConfigModel.showReceivedFields = function () {
      var productType = _.get(siteConfigModel.siteConfig(), 'productType');
      return _.includes(['CPC', 'VNG_CPC'], productType) || siteConfigModel.isPo();
    };

    siteConfigModel.approvalSettingOnForRole = function () {
      return settingOn('APPROVAL');
    };

    siteConfigModel.approvalSettingOnForSite = function () {
      var roleOptions = _.get(siteConfigModel.siteConfig(), 'roleOptions', []);

      return _.includes(_.flatMapDeep(roleOptions), 'APPROVAL');
    };

    siteConfigModel.massUpdateOn = function () {
      return settingOn('MASS_UPDATE');
    };

    siteConfigModel.cycleLevelApprovalOn = function () {
      return settingOn('CYCLE_UPDATE');
    };

    siteConfigModel.clearExceptionOn = function () {
      return settingOn('CLEAR_EXCEPTION');
    };

    siteConfigModel.approveOnReallocationEnabled = function () {
      return settingOn('APPROVE_ON_REALLOCATION');
    };

    siteConfigModel.isOibEnabled = function () {
      return _.get(siteConfigModel.siteConfig(), 'openItemBilling', false);
    };

    siteConfigModel.isMeetings360 = function () {
      return _.get(siteConfigModel.siteConfig(), 'meetings360', false);
    };

    siteConfigModel.isPo = function () {
      return _.get(siteConfigModel.siteConfig(), 'purchaseOrder', false);
    };

    siteConfigModel.isCmc = function () {
      var productType = _.get(siteConfigModel.siteConfig(), 'productType');
      return _.includes(['CMC'], productType);
    };

    siteConfigModel.isCpc = function () {
      var productType = _.get(siteConfigModel.siteConfig(), 'productType');

      return _.includes(['CPC'], productType);
    };

    siteConfigModel.displayCustomizableColumn = function() {
      return siteConfigModel.isCmc() || siteConfigModel.isCpc() || siteConfigModel.isMeetings360() || siteConfigModel.isPo()
          || siteConfigModel.isPreAuth() || siteConfigModel.isBtaProductType();
    };

    function settingOn(type) {
      var roleOptions = _.get(siteConfigModel.siteConfig(), 'roleOptions', []);
      var role;

      if (TransactionSearchModel.isBcaManager()) {
        role = 'BCA_MANAGER';
      } else if (TransactionSearchModel.isAccountingManager()) {
        role = 'ACCOUNTING_MANAGER';
      } else if (TransactionSearchModel.isCardManager()) {
        role = 'CARD_MANAGER';
      } else if (TransactionSearchModel.isCardMember()) {
        role = 'CARDMEMBER';
      } else if (TransactionSearchModel.isBtaManager()) {
          role = 'BTA_MANAGER';
      }

      return _.includes(_.get(roleOptions, role), type);
    }

    siteConfigModel.approvalEnabledForBcaManager = function () {
      return actionEnabled('BCA_MANAGER', 'APPROVAL');
    };

    siteConfigModel.approvalEnabledForCardManager = function () {
      return actionEnabled('CARD_MANAGER', 'APPROVAL');
    };

    siteConfigModel.approvalEnabledForCardmember = function () {
      return actionEnabled('CARDMEMBER', 'APPROVAL');
    };

    siteConfigModel.approvalEnabledForAccountingManager = function () {
      return actionEnabled('ACCOUNTING_MANAGER', 'APPROVAL');
    };
    
    siteConfigModel.clearApprovalEnabledForBcaManager = function () {
      return actionEnabled('BCA_MANAGER', 'CLEAR_APPROVAL');
    };

    siteConfigModel.clearApprovalEnabledForBtaManager = function () {
        return actionEnabled('BTA_MANAGER', 'CLEAR_APPROVAL');
    };

    siteConfigModel.clearApprovalEnabledForCardManager = function () {
      return actionEnabled('CARD_MANAGER', 'CLEAR_APPROVAL');
    };

    siteConfigModel.clearApprovalEnabledForCardmember = function () {
      return actionEnabled('CARDMEMBER', 'CLEAR_APPROVAL');
    };

    siteConfigModel.clearApprovalEnabledForAccountingManager = function () {
      return actionEnabled('ACCOUNTING_MANAGER', 'CLEAR_APPROVAL');
    };
    
    siteConfigModel.clearApprovalEnabledForRole = function(role) {
      return actionEnabled(convertRoleNameForRoleOptions(role), 'CLEAR_APPROVAL');
    };

    siteConfigModel.deleteReceiptEnabledForRole = function(role) {
      return actionEnabled(convertRoleNameForRoleOptions(role), 'DELETE_RECEIPT');
    };

    siteConfigModel.holdTransactionEnabledForRole = function(role) {
      return actionEnabled(convertRoleNameForRoleOptions(role), 'HOLD_TRAN');
    };

    siteConfigModel.isActualTaxAllocationEditDisabled = function() {
      var indicator = _.get(siteConfigModel.siteConfig(),'lineItemDetailDeriveIndicator');
      var taxIndicators = ['AUTOMATICALLY_SPLIT_FROM_LID_AND_ALLOCATE_TAX', 'SUMMARIZE_LID_AND_ALLOCATE_TAX'];
      return !_.get(siteConfigModel.siteConfig(), 'allowVatEditIndicator', true)
        && _.includes(taxIndicators, indicator);
    };

    siteConfigModel.isNonTaxAllocationEditDisabled = function() {
      return _.get(siteConfigModel.siteConfig(), 'nonTaxAllocationEditDisabled', false);
    };

    siteConfigModel.getAvailableColumns = function () {
      var listOfCoulumns = [
          {type: 'general', value: 'Lock Status (Icon)', displayValue: 'Lock Status (Icon)',transactionDBFieldName: 'lockStatus',  translateValue : 'Lock Status (Icon)', widthValue: 25},
          {type: 'general', value: 'Status (Icon)', displayValue: 'Status (Icon)',transactionDBFieldName: '',  translateValue : 'Status (Icon)', widthValue:25},
          {type: 'general', value: 'Exception (Icon)', displayValue: 'Exception (Icon)',transactionDBFieldName: '',  translateValue : 'Exception (Icon)', widthValue:25},
          {type: 'general', value: 'LID (Icon)', displayValue: 'LID (Icon)',transactionDBFieldName: '',  translateValue : 'LID (Icon)', widthValue:25},
          {type: 'general', value: 'Comment (Icon)', displayValue: 'Comment (Icon)',transactionDBFieldName: '',  translateValue : 'Comment (Icon)', widthValue:25},
          {type: 'general', value: 'Date', displayValue: 'Date', translateValue : 'transactions.Date', widthValue:80},
          {type: 'general', value: 'Business Process Date', displayValue: 'Business Process Date',transactionDBFieldName: 'businessProcessDate',  translateValue : 'transactionFieldDropdown.businessProcessDate', widthValue:120},
          {type: 'general', value: 'Amount', displayValue: 'Amount',transactionDBFieldName: 'amount',  translateValue : 'transactions.Amount', widthValue:120},
          {type: 'general', value: 'Local Amount & Currency Code', displayValue: 'Local Amount & Currency Code',transactionDBFieldName: 'localAmountAndCurrencyCode',  translateValue : 'transactionFieldDropdown.localAmountAndCurrencyCode', widthValue:140},
          {type: 'general', value: 'Billed Tax Amount', displayValue: 'Billed Tax Amount',transactionDBFieldName: 'billedTaxAmount',  translateValue : 'transactionFieldDropdown.billedTaxAmount', widthValue:80},
          {type: 'general', value: 'Merchant Name 1', displayValue: 'Merchant Name 1',transactionDBFieldName: '',  translateValue : 'transactions.MerchantNameOne', widthValue:140},
          {type: 'general', value: 'Merchant Name 2', displayValue: 'Merchant Name 2',transactionDBFieldName: '',  translateValue : 'transactions.MerchantNameTwo', widthValue:140},
          {type: 'general', value: 'Cardmember Name', displayValue: 'Cardmember Name',transactionDBFieldName: 'cardmemberName',  translateValue : 'transactions.CardmemberName', widthValue:120},
          {type: 'general', value: 'Cardmember Name and Card Number', displayValue: 'Cardmember Name and Card Number',transactionDBFieldName: 'cardmemberNameAndNumber',  translateValue : 'transactionFieldDropdown.cardmemberNameAndNumber', widthValue:180},
          {type: 'general', value: 'Cardmember Reference 1', displayValue: 'Cardmember Reference 1',transactionDBFieldName: 'cardmemberReference1',  translateValue : 'transactionFieldDropdown.cardmemberReference1', widthValue:140},
          {type: 'general', value: 'Cardmember Reference 2', displayValue: 'Cardmember Reference 2',transactionDBFieldName: 'cardmemberReference2',  translateValue : 'transactionFieldDropdown.cardmemberReference2', widthValue:140},
          {type: 'general', value: 'Cardmember Reference 3', displayValue: 'Cardmember Reference 3',transactionDBFieldName: 'cardmemberReference3',  translateValue : 'transactionFieldDropdown.cardmemberReference3', widthValue:140},
          {type: 'general', value: 'Cardmember Reference 4', displayValue: 'Cardmember Reference 4',transactionDBFieldName: 'cardmemberReference4',  translateValue : 'export.field.CardmemberReference4', widthValue:140},
          {type: 'general', value: 'Transaction Reference Number', displayValue: 'Transaction Reference Number',transactionDBFieldName: 'TRANSACTIONREFNUMBER',  translateValue : 'transactionFieldDropdown.TRANSACTIONREFNUMBER', widthValue:140},
          {type: 'general', value: 'Merchant Reference Number', displayValue: 'Merchant Reference Number',transactionDBFieldName: 'Merchant Reference Number',  translateValue : 'export.field.MerchantReferenceNumber', widthValue:140},
          //{type: 'general', value: 'Invoice Number', displayValue: 'Invoice Number',transactionDBFieldName: '',  translateValue : '', widthValue:80},
          {type: 'general', value: 'Description 1', displayValue: 'Description 1',transactionDBFieldName: 'descriptionLine1',  translateValue : 'transactionFieldDropdown.descriptionLine1', widthValue:120},
          {type: 'general', value: 'Description 2', displayValue: 'Description 2',transactionDBFieldName: 'descriptionLine2',  translateValue : 'transactionFieldDropdown.descriptionLine2', widthValue:120},
          {type: 'general', value: 'Description 3', displayValue: 'Description 3',transactionDBFieldName: 'descriptionLine3',  translateValue : 'transactionFieldDropdown.descriptionLine3', widthValue:120},
          {type: 'general', value: 'Description 4', displayValue: 'Description 4',transactionDBFieldName: 'descriptionLine4',  translateValue : 'transactionFieldDropdown.descriptionLine4', widthValue:120},
          {type: 'general', value: 'Merchant Location', displayValue: 'Merchant Location',transactionDBFieldName: 'merchantLocation',  translateValue : 'transactionFieldDropdown.merchantLocation', widthValue:140},
          {type: 'general', value: 'Last Updated', displayValue: 'Last Updated',transactionDBFieldName: 'transactionLastUpdated',  translateValue : 'transactionFieldDropdown.transactionLastUpdated', widthValue:160},
        //  {type: 'general', value: 'Cardmember Comments', displayValue: 'Cardmember Comments',transactionDBFieldName: '',  translateValue : '', widthValue:140},
         // {type: 'general', value: 'Manager Comments', displayValue: 'Manager Comments',transactionDBFieldName: '',  translateValue : '', widthValue:140},
         {type: 'general', value: 'Allocation Description', displayValue: 'Allocation Description',transactionDBFieldName: '',  translateValue : 'transactions.AllocationDescription', widthValue:180},
          {type: 'general', value: 'Matched PO#', displayValue: 'Matched PO#', transactionDBFieldName:'matchedPO', translateValue : 'thirdPartyData.invoiceNumber', widthValue:180},
          {type: 'general', value: 'PO Number', displayValue: 'PO Number',transactionDBFieldName: 'poNumber',  translateValue : 'transactions.purchaseOrder.PoNumber', widthValue:120},


    ];

      // settings accounting fields...
      var accountFields = siteConfigModel.getAccountingFieldSchemas();
      for (var key in accountFields) {
          listOfCoulumns.push({
              type: 'ACF',
              value: accountFields[key].position,
              displayValue: accountFields[key].label,
              translateValue : accountFields[key].label,
              widthValue:150,
              transactionDBFieldName: ''
          });
      }

      if(siteConfigModel.transactionReceiptsEnabled()) {
        listOfCoulumns.push({type: 'general', value: 'Receipts (Icon)', displayValue: 'Receipts (Icon)',transactionDBFieldName: '',  translateValue : 'transactions.transactionListHeader.Receipts', widthValue:25});
      }

      if(siteConfigModel.isBta() || siteConfigModel.isPo() || siteConfigModel.isMeetings360()) {
        listOfCoulumns.push({type: 'general', value: 'Linked/Matched (Icon)', displayValue: 'Linked/Matched (Icon)',transactionDBFieldName: '',  translateValue : 'transactions.transactionListHeader.TPDMatch', widthValue:25});
      }

      // BTA fields...
      if (siteConfigModel.isBtaProductType() || siteConfigModel.isVngBtaProductType()) {
          listOfCoulumns.push({type: 'general', value: 'Traveler Name', displayValue: 'Traveler Name',transactionDBFieldName: 'travelerName',  translateValue : 'transactionFieldDropdown.travelerName', widthValue:140});
          listOfCoulumns.push({type: 'general', value: 'Ticket Number', displayValue: 'Ticket Number',transactionDBFieldName: 'ticketNumber',  translateValue : 'transactionFieldDropdown.ticketNumber', widthValue:120});
          listOfCoulumns.push({type: 'general', value: 'OpenText 17', displayValue: 'OpenText 17',transactionDBFieldName: 'OpenText17',  translateValue : 'transactionFieldDropdown.OpenText17', widthValue:120});
          listOfCoulumns.push({type: 'general', value: 'OpenText 18', displayValue: 'OpenText 18',transactionDBFieldName: 'OpenText18',  translateValue : 'transactionFieldDropdown.OpenText18', widthValue:120});
          listOfCoulumns.push({type: 'general', value: 'OpenText 19', displayValue: 'OpenText 19',transactionDBFieldName: 'OpenText19',  translateValue : 'transactionFieldDropdown.OpenText19', widthValue:120});
          listOfCoulumns.push({type: 'general', value: 'OpenText 20', displayValue: 'OpenText 20',transactionDBFieldName: 'OpenText20',  translateValue : 'transactionFieldDropdown.OpenText20', widthValue:120});
      }
      // PO fields.
      if (siteConfigModel.isPo()) {
          listOfCoulumns.push({type: 'general', value: 'PO#', displayValue: 'PO#',transactionDBFieldName: 'poNumber#',  translateValue : 'transactions.purchaseOrder.PoNumber', widthValue:120});
      }

        /*if (siteConfigModel.isPoNumber()) {
            listOfCoulumns.push({type: 'general', value: 'PO Number', displayValue: 'PO Number',transactionDBFieldName: 'poNumber',  translateValue : 'transactions.purchaseOrder.PoNumber', widthValue:120});
        }*/


      if (siteConfigModel.isPreAuth()) {
          listOfCoulumns.push({type: 'general', value: 'Pre Auth Id', displayValue: 'Pre Auth Id',transactionDBFieldName: 'preAuthId',  translateValue : 'transactionFieldDropdown.preAuthId', widthValue:120});
      }
      if (siteConfigModel.approvalSettingOnForSite()) {
          listOfCoulumns.push({type: 'general', value: 'Approvals (Icon)', displayValue: 'Approvals (Icon)',transactionDBFieldName: '',  translateValue : 'Approvals (Icon)', widthValue:140});
      }
      return listOfCoulumns;
    };


    function actionEnabled(role, action) {
      var roleOptions = _.get(siteConfigModel.siteConfig(), 'roleOptions', []);
      return _.includes(_.get(roleOptions, role), action);
    }

    function siteForReceipts (status) {
      return _.get(siteConfigModel.siteConfig(), 'receiptsEnabled', 'OFF') === status;
    }

    function convertRoleNameForRoleOptions(role) {
      var roleOptionsRoleName = _.find(_.keys(roles),function(key) { return roles[key] == role; });
      if (roleOptionsRoleName) {
        return roleOptionsRoleName;
      } else {
        return role;
      }
    }

      siteConfigModel.isColoumnSelected = function (fieldName) {
          return selectedFileds.indexOf(fieldName) > -1;
      };

      siteConfigModel.selectedHeaderColumns = function (listOfCoulumns, siteNumber) {
          if (UserModel.currentUserPreferences() != undefined  && UserModel.currentUserPreferences().allSitesColumnPreference != undefined && UserModel.currentUserPreferences().allSitesColumnPreference.length > 0) {
              var sitesColumnSettings = _.find(UserModel.currentUserPreferences().allSitesColumnPreference, {'siteNumber': siteNumber});
              if (sitesColumnSettings) {
                  var selectedColumnsArray = sitesColumnSettings.horizontalColumns;
                  if (selectedColumnsArray) {
                      for (var i = 0; i < selectedColumnsArray.length; i++) {
                          if (selectedColumnsArray[i].type === 'ACF') {
                              var columnHeaderInfo = _.find(listOfCoulumns, {value: Number(selectedColumnsArray[i].value)});
                              if(columnHeaderInfo) {
                                  selectedColumnsArray[i].displayValue = columnHeaderInfo.displayValue;
                                  selectedColumnsArray[i].value = columnHeaderInfo.value;
                              }
                          } else {
                              selectedColumnsArray[i].displayValue = selectedColumnsArray[i].value;
                          }
                          var variableFromListOfColumns = _.find(listOfCoulumns, {value: selectedColumnsArray[i].value});

                          if (variableFromListOfColumns && variableFromListOfColumns.widthValue !== undefined) {
                              selectedColumnsArray[i].widthValue = variableFromListOfColumns.widthValue;
                          }
                          if (variableFromListOfColumns && variableFromListOfColumns.translateValue !== undefined) {
                              selectedColumnsArray[i].translateValue = variableFromListOfColumns.translateValue;
                          }
                          if (variableFromListOfColumns && variableFromListOfColumns.transactionDBFieldName !== undefined) {
                              selectedColumnsArray[i].transactionDBFieldName = variableFromListOfColumns.transactionDBFieldName;
                          }


                      }
                  }
              } else {
                  return getDefaultFields(listOfCoulumns);
              }
              return selectedColumnsArray;
          } else {
              return getDefaultFields(listOfCoulumns);
          }
      };

      function getDefaultFields(listOfCoulumns){
          var defaultColHeaders = ['Lock Status (Icon)',
              'Status (Icon)',
              'Exception (Icon)',
              'LID (Icon)',
              'Comment (Icon)',
              'Date',
              'Merchant Name 2',
              'Amount',
              'Receipts (Icon)',
              'Linked/Matched (Icon)',
              'Approvals (Icon)'];
          var selectedcols =  _.filter(listOfCoulumns,function (value) {return defaultColHeaders.indexOf(value.displayValue) > -1;});
          var accountFieldsByTypes =  _.filter(listOfCoulumns,function (value) {return (value.type === 'ACF');});
          if(accountFieldsByTypes !== undefined && accountFieldsByTypes.length > 1) {
              selectedcols.push(accountFieldsByTypes[0]);
              selectedcols.push(accountFieldsByTypes[1]);
          }
          return selectedcols;
      }
    return siteConfigModel;
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/models/SiteConfigModel.js
// module id = 586
// module chunks = 0